import { Chip, LinearProgress, Stack, Typography, useTheme } from "@mui/material"
import { ArrowSwapHorizontal } from "iconsax-react"
import moment from "jalali-moment"
import { useEffect, useMemo, useState } from "react"
import { toast } from "react-toastify"
import TransactionServices from "../../../services/transactions"
import ReactTable from "../../common/react-table"
import TableHeader from "../../common/table-header"
import TablePagination from "../../common/table-pagination"
import DesktopWrapper from "../../layout/desktop/desktop-wrapper"
import TransactionsFilter from "./filter"
import { TableContainer } from "./transactions.styles"

const Transactions = () => {
  const theme = useTheme()

  const columns = useMemo(
    () => [
      {
        Header: <TableHeader header='مبلغ' />,
        accessor: "amount",
        disableFilters: true,
        Cell: cell => {
          return <Typography>{Number(cell?.row?.original?.amount).toLocaleString()} ریال</Typography>
        }
      },
      {
        Header: <TableHeader header='پذیرنده' />,
        accessor: "merchantName",
        disableFilters: true,
        Cell: cell => {
          cell?.row?.original?.merchantName ? (
            <Chip
              color='default'
              size='small'
              sx={{ borderRadius: "4px", fontSize: 12 }}
              label={cell?.row?.original?.merchantName}
            />
          ) : null
        }
      },
      {
        Header: <TableHeader header='تاریخ' />,
        accessor: "date",
        disableFilters: true,
        Cell: cell => {
          return (
            <Typography variant='caption'>
              {moment(cell?.row?.original?.date).locale("fa").format("YYYY/M/D HH:mm:ss")}
            </Typography>
          )
        }
      },
      {
        Header: <TableHeader header='نوع تراکنش' />,
        accessor: "typeName",
        disableFilters: true
      },
      {
        Header: <TableHeader header='توضیحات' />,
        accessor: "description",
        disableFilters: true
      }
    ],
    []
  )

  const [data, setData] = useState([])
  const [controller, setController] = useState({
    total: 0,
    pageIndex: 0,
    pageSize: 5
  })
  const [filterData, setFilterData] = useState({})
  const [state, setState] = useState("loading" | "error" | "done")

  /**
   * Methods
   * _______________________________________________________________________________
   */

  const getTransactionsList = () => {
    setState("loading")
    const filter = {
      PageSize: controller?.pageSize,
      PageIndex: controller?.pageIndex + 1,
      Type: filterData?.type?.id || undefined,
      StartDate: filterData?.startDate || undefined,
      EndDate: filterData?.endDate || undefined
    }

    TransactionServices?.getTransactionList(filter).then(response => {
      if (response?.status === 200) {
        if (!response?.data?.succeed) {
          setState("error")
          toast.error(response?.data?.message)
        } else {
          setController(perv => ({
            ...perv,
            total: response?.data?.value?.total
          }))
          setData(response?.data?.value?.list)
          setState("done")
        }
      }
    })
  }

  const onPageSelect = pageNo =>
    setController(perv => ({
      ...perv,
      pageIndex: pageNo
    }))

  useEffect(() => {
    getTransactionsList()
  }, [controller?.pageIndex, filterData])

  /**
   * Template
   * _______________________________________________________________________________
   */
  if (data) {
    return (
      <DesktopWrapper title='تراکنش ها'>
        <TableContainer>
          <TransactionsFilter submitForm={value => setFilterData(value)} />
          <ReactTable data={data} columns={columns} />
          {state === "loading" && <LinearProgress color='info' />}
          <TablePagination
            total={controller?.total}
            selectPage={onPageSelect}
            pageIndex={controller?.pageIndex}
            pageSize={controller?.pageSize}
          />
        </TableContainer>
      </DesktopWrapper>
    )
  } else {
    return (
      <Stack direction='row' justifyContent='center' mt={20}>
        <Stack spacing={3}>
          <Stack direction='row' justifyContent='center'>
            <ArrowSwapHorizontal size={50} color={theme.palette.primary.main} />
          </Stack>

          <Typography variant='h3' fontWeight='normal'>
            تراکنشی وجود ندارد
          </Typography>
        </Stack>
      </Stack>
    )
  }
}

export default Transactions
